class LocationUtil {
    hasMultiLocations(){
        let locations = this.getLocations();
        return (locations.length > 1);
    }

    getLocations(){
        let user = JSON.parse(localStorage.getItem('user'));
        let locations = user.locations;
        return locations;
    }

    /**
     * The accounting systems this merchant actually uses — the distinct set across their locations.
     *
     * A SET, not a single value: `accountingSystem` is chosen per LOCATION, so a group can run Fiken
     * at one restaurant and Tripletex at another, and both menus have to appear. `NONE` is not a
     * system, so it is left out.
     *
     * Reads the cached locations, which MerchantUtil refreshes from listLocations() — the same source
     * the sync pages filter on, so the menu and the pages agree about what is configured.
     */
    getAccountingSystems(){
        let systems = new Set();
        let locations;
        try {
            locations = this.getLocations();
        } catch (e) {
            return systems;
        }
        if(!locations){
            return systems;
        }
        for (let i = 0; i < locations.length; i++) {
            let accountingSystem = locations[i].accountingSystem;
            if(accountingSystem && accountingSystem !== 'NONE'){
                systems.add(accountingSystem);
            }
        }
        return systems;
    }

    getLocation(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let locations = user.locations;
        for (let i = 0; i < locations.length; i++) {
            let location = locations[i];
            if(location.id == locationId){
                return location;
            }
        }
        return undefined;
    }
}

export default new LocationUtil();
